// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3pdB1","messages":"Chat_messages__LpP5e","dateDivider":"Chat_dateDivider__2I1de"};